module.exports = __webpack_public_path__ + "img/grayBarEnd.ffe04aa6.svg";